// @flow

import React from 'react';
import PropTypes from 'prop-types';
import Picker from '@emoji-mart/react';

import {makeStyles} from '@material-ui/core';

export type Emoji = {
  id: string,
  name: string,
  native: string,
  keywords: string[],
  shortcodes: string,
  emoticons: string,
  unified: string,
};

type Props = {
  onEmojiPick: (emoji: Emoji) => void,
};

const useStyles = makeStyles(() => ({
  emojiPicker: {
    '& .epr-preview': {
      display: 'none!important',
    },
  },
}));

export default function EmojiPicker(props: Props) {
  const {onEmojiPick, ...otherProps} = props;

  const classes = useStyles();
  return (
    <div className={classes.emojiPicker}>
      <Picker
        onEmojiSelect={onEmojiPick}
        locale="es"
        theme="light"
        {...(otherProps: any)}
      />
    </div>
  );
}

EmojiPicker.propTypes = {
  onEmojiPick: PropTypes.func.isRequired,
};
